import React from "react";
import DagBoek from "./DagBoek";

const DagBoekList = ({ dagboeken, editTekst, showText }) => {
  return (
    <ul className="w-full space-y-2 pb-4">
      {dagboeken.map((dagboek, index) => (
        <DagBoek
          key={dagboek?.eetdagboek_id ?? index}
          editTekst={editTekst}
          toonEdit={showText}
          item={dagboek}
        />
      ))}
    </ul>
  );
};

export default DagBoekList;
